import { UserDto } from 'src/dtos';
import { User } from 'src/models';

import { mapAccountDtoToModel } from './account.mapper';

export const mapUserDtoToModel = (userDto: UserDto): User => ({
  ...userDto,
  accounts: userDto.accounts.map(accountDto => mapAccountDtoToModel(accountDto)),
  accountLinks: userDto.accountLinks?.map(accountDto => mapAccountDtoToModel(accountDto)),
});
